module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/atm-5de02b329cf846e3da867b2b3e16910c.svg";